





import { Component, Provide, Vue } from 'vue-property-decorator'

import SearchAll from './components/searchAll/all_hzw.vue'
import { SearchTotalRequest } from './search-service'
import { getSelectedCityId } from '@utils/index'

@Component({
  components: {
    SearchAll
  }
})
export default class SearchYuer extends Vue {
 

  @Provide()
  pageTrackParams: any = {
    bizType: '127',
    pageLevelId: '121012977',
    pageParam: {
      keyword: this.$route.query &&  this.$route.query.searchKey,
      citycode: getSelectedCityId()
    }
  }
  @Provide()
  clickid_200007 = '200007'
  @Provide()
  clickid_200004 = '200004'
  @Provide()
  clickid_200003 = '200003'
  @Provide()
  clickid_200002 = '200002'
  @Provide()
  clickid_200001 = '200001'
  @Provide()
  clickid_200019 = '200019'
  @Provide()
  clickid_200018 = '200018'
  @Provide()
  clickid_200017 = '200017'
  @Provide()
  clickid_200016 = '200016'
  @Provide()
  clickid_200015 = '200015'
  @Provide()
  clickid_200014 = '200014'
  @Provide()
  clickid_200013 = '200013'
  @Provide()
  clickid_200012 = '200012'
  @Provide()
  clickid_200011 = '200011'
  @Provide()
  clickid_200010 = '200010'
  @Provide()
  clickid_200009 = '200009'
  @Provide()
  clickid_200008 = '200008'

  async created() {
    //type搜索类型（2-商家 4-月嫂） //默认展示商家
    const parms: SearchTotalRequest = {}
    
  }
}
